
export enum GisOutstandingItemRequestType {
  AllBills = 0,
  AllOutstandingBills = 1,
  AllDueBills = 2
}
